import Checkbox from '@components/Checkbox'
import VehicleFormModal from 'shared/components/VehicleFormModal'
import { vehiclesSelector } from 'dashboard-vehicles/selectors'
import styles from './styles.module.scss'

const formatVehicleLabel = vehicle => [vehicle?.make, vehicle?.model, vehicle?.tag].filter(Boolean).join(' ')

const VehiclesList = ({ vehicles = [], selectedVehicleIds = [], onToggle }) => (
    <>
        {vehicles.length > 0 && (
            <ul className={styles.vehiclesList}>
                {vehicles.map(vehicle => {
                    const checked = selectedVehicleIds.includes(vehicle.id)
                    return (
                        <li key={vehicle.id}>
                            <Checkbox
                                checked={checked}
                                onChange={() => onToggle(vehicle.id)}
                                label={formatVehicleLabel(vehicle)}
                            />
                        </li>
                    )
                })}
            </ul>
        )}
        <VehicleFormModal btnType="outline" />
    </>
)

const mapStateToProps = createStructuredSelector({
    vehicles: vehiclesSelector,
})

export default compose(connect(mapStateToProps))(VehiclesList)
